import {
  setFlagData,
  useSelectFlagData,
} from "../../../../../redux/features/flagDetails/flagDetailsSlice";
import { useRole } from "../../../../../redux/features/user";
import { useMutation } from "@tanstack/react-query";
import { changeFlagStatus } from "../../../../../services/flag";
import { cutDate } from "../../../../../utils/functions";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";

const useStatusResolution = () => {
  const dispatch = useDispatch();
  const flagData = useSelectFlagData();
  const role = useRole();

  const {
    id,
    locked,
    resolution: resolutionStatus,
    dueDate,
    dueDateCheck,
    status: flagStatus,
  } = flagData?.flagDetails || {};

  const { mutateAsync } = useMutation({
    mutationKey: ["due-date-checkbox", id, resolutionStatus],
    mutationFn: () =>
      changeFlagStatus({
        resolutionStatus,
        id,
        dueDate: cutDate(dueDate),
        dueDateCheck: true,
      }),
  });

  const handleDueDateCheck = async () => {
    const { data } = await mutateAsync();
    dispatch(setFlagData(data));
  };

  const isEscalated = flagStatus === "ESCALATED";

  const { inProgressGroupOptions, completedGroupOptions } = createOptions();

  if (role === "AML_MANAGER" || role === "GRANT_ADMIN") {
    inProgressGroupOptions.push({
      value: "INCREASEDRISK",
      label: "Increased risk",
      type: "In Progress",
    });
    inProgressGroupOptions.push({
      value: "DECREASEDRISK",
      label: "Decreased risk",
      type: "In Progress",
    });
  }

  const options = [
    { group: "Completed", items: completedGroupOptions },
    { group: "In Progress", items: inProgressGroupOptions },
  ];
  const canClickCheckBox =
    resolutionStatus === "FOR_MONITORING" ||
    resolutionStatus === "DOCUMENT_ENQUIRY";

  const isPastDate = dayjs(dueDate).isBefore(new Date());

  return {
    options,
    resolutionStatus,
    locked,
    flagStatus,
    dueDate,
    dueDateCheck,
    isEscalated,
    role,
    canClickCheckBox,
    isPastDate,
    id,
    handleDueDateCheck,
  };
};

function createOptions() {
  // recreation on every rerender
  const inProgressGroupOptions = [
    {
      label: "Document Enquiry",
      value: "DOCUMENT_ENQUIRY",
      type: "In Progress",
    },
    {
      label: "For Investigation",
      value: "FOR_INVESTIGATION",
      type: "In Progress",
    },
  ];

  const completedGroupOptions = [
    { label: "False Positive", value: "FALSE_POSITIVE", type: "Completed" },
    {
      label: "Termination of the contract",
      value: "TERMINATION_OF_CONTRACT",
      type: "Completed",
    },
    {
      label: "Transaction allowed",
      value: "TRANSACTION_ALLOWED",
      type: "Completed",
    },
    { label: "Stop the operation", value: "STOP_OPERATION", type: "Completed" },
    { label: "For Reporting", value: "FOR_REPORTING", type: "Completed" },
    { label: "For Monitoring", value: "FOR_MONITORING", type: "Completed" },
    { label: "Customer Warning", value: "CUSTOMER_WARNING", type: "Completed" },
    { label: "Red Flag", value: "RED_FLAG", type: "Completed" },
  ];

  return { inProgressGroupOptions, completedGroupOptions };
}

export default useStatusResolution;
